import { GithubTokenMessageListenerService } from './github-installation-message-listener.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GithubWdfInstallationRequestListener extends GithubTokenMessageListenerService {
  domain = 'github.wdf.sap.corp';
}
